export const OnteexStatus = {
  SUCCESS: 'success',
  CANCEL: 'cancel'
};
Object.freeze(OnteexStatus);
